import React from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { Helmet } from 'react-helmet-async';
import { faEdit, faBan } from '@fortawesome/free-solid-svg-icons';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import toast from 'react-hot-toast';

import DataState from '../DataState';
import {
  TitleContainer,
  Title,
  TableContainer,
  TableTitleContainer,
  TableTitle,
  TableTitleNew,
  TableTitleIcon,
  Table,
  Row,
  HeaderCell,
  Cell,
  Label,
  ActionButton,
  ActionIcon,
} from '../../elements';

import {
  MobileTable,
  MobileTableRow,
  MobileTableHeader,
  MobileTableCell,
  MobileTableActionCell,
  MobileTableData,
} from '../../elements/mobileTable';

import { OWNER_PORTAL_USERS, DELETE_OWNER_PORTAL_USER } from './queries';

const Users = () => {
  const { loading, error, data, refetch } = useQuery(OWNER_PORTAL_USERS);

  const [deleteOwnerPortalUser] = useMutation(DELETE_OWNER_PORTAL_USER, {
    onCompleted: () => {
      refetch();
      toast('User Deleted.');
    }
  });

  const removeAccess = (e, ownerPortalUser) => {
    e.preventDefault();

    if (window.confirm(
      'Are you sure you want to remove access for ' +
        ownerPortalUser.portalUser.fullName + '?'
    )) {
      deleteOwnerPortalUser({ variables: { id: ownerPortalUser.id } })
    }
  }

  if (loading && !data) return <DataState.Loading />;
  if (error) return <DataState.Error error={error} />;

  const fbo = data.currentOwner;
  const users = data.currentOwner.ownerPortalUsers;

  return (
    <>
      <Helmet>
         <title>Users</title>
      </Helmet>

      <TitleContainer>
        <Title>Users</Title>
      </TitleContainer>

      <TableContainer className="mobileCollapse">
        <TableTitleContainer>
          <TableTitle>{fbo.name} - Users</TableTitle>
          <TableTitleNew to="/users/new">
            <TableTitleIcon icon={faCirclePlus} />
          </TableTitleNew>
        </TableTitleContainer>

        <Table>
          <thead>
            <Row>
              <HeaderCell>Name</HeaderCell>
              <HeaderCell>Email</HeaderCell>
              <HeaderCell>Office Phone</HeaderCell>
              <HeaderCell>Cell Phone</HeaderCell>
              <HeaderCell>User Type</HeaderCell>
              <HeaderCell style={{borderRight: '0px'}}>Actions</HeaderCell>
            </Row>
          </thead>
          <tbody>
            {users.map(user => (
              <Row key={user.id}>
                <Cell>{user.portalUser.fullName}</Cell>
                <Cell>{user.portalUser.email}</Cell>
                <Cell>{user.portalUser.officePhone?.formatted}</Cell>
                <Cell>{user.portalUser.mobilePhone?.formatted}</Cell>
                <Cell>{user.role}</Cell>
                <Cell style={{borderRight: '0px'}}>
                  <ActionButton to={`/users/${user.id}/edit`}>
                    <ActionIcon icon={faEdit} />
                    Edit
                  </ActionButton>

                  <ActionButton
                    to="/users"
                    onClick={e => removeAccess(e, user)}
                  >
                    <ActionIcon icon={faBan} />
                    Delete
                  </ActionButton>
                </Cell>
              </Row>
            ))}
          </tbody>
        </Table>

        <MobileTable>
          {users.map(user => (
            <MobileTableRow key={user.id}>
              {toggleDetails => (
                <>
                  <MobileTableHeader>
                    {toggleDetails}
                    <Label>Name</Label>
                    <MobileTableData>
                      {user.portalUser.fullName}
                    </MobileTableData>
                  </MobileTableHeader>
                  <MobileTableCell>
                    <Label>Email</Label>
                    <MobileTableData>{user.portalUser.email}</MobileTableData>
                  </MobileTableCell>
                  <MobileTableCell>
                    <Label>Office Phone</Label>
                    <MobileTableData>
                      {user.portalUser.officePhone?.formatted}
                    </MobileTableData>
                  </MobileTableCell>
                  <MobileTableCell>
                    <Label>Cell Phone</Label>
                    <MobileTableData>
                      {user.portalUser.mobilePhone?.formatted}
                    </MobileTableData>
                  </MobileTableCell>
                  <MobileTableCell>
                    <Label>User Type</Label>
                    <MobileTableData>{user.role}</MobileTableData>
                  </MobileTableCell>
                  <MobileTableActionCell>
                    <ActionButton to={`/users/${user.id}/edit`}>
                      <ActionIcon icon={faEdit} />
                      Edit
                    </ActionButton>

                    <ActionButton
                      to="/users"
                      onClick={e => removeAccess(e, user)}
                    >
                      <ActionIcon icon={faBan} />
                      Delete
                    </ActionButton>
                  </MobileTableActionCell>
                </>
              )}
            </MobileTableRow>
          ))}
        </MobileTable>
      </TableContainer>
    </>
  );
};

export default Users;
